import { schema } from "normalizr";

const projectCategory = new schema.Entity(`projectCategories`);
const arrayOfProjectCategories = [projectCategory];

export { projectCategory, arrayOfProjectCategories };
